/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvestmentDetailsAssetAllocationViewModel
 */
export interface InvestmentDetailsAssetAllocationViewModel {
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsAssetAllocationViewModel
     */
    productSelectedAssetId?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsAssetAllocationViewModel
     */
    assetCode: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsAssetAllocationViewModel
     */
    lumpSumPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsAssetAllocationViewModel
     */
    transferPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsAssetAllocationViewModel
     */
    recurringPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsAssetAllocationViewModel
     */
    defaultTransferPercentage?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsAssetAllocationViewModel
     */
    unitTransferSourceAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsAssetAllocationViewModel
     */
    onceOffInvestmentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof InvestmentDetailsAssetAllocationViewModel
     */
    onceOffInvestmentPercentage?: number;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentDetailsAssetAllocationViewModel
     */
    isDefaultTransferPercentageMax?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentDetailsAssetAllocationViewModel
     */
    isOwnFundAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvestmentDetailsAssetAllocationViewModel
     */
    isUnitTransferAvailable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvestmentDetailsAssetAllocationViewModel
     */
    jSECode?: string;
}

/**
 * Check if a given object implements the InvestmentDetailsAssetAllocationViewModel interface.
 */
export function instanceOfInvestmentDetailsAssetAllocationViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assetCode" in value;

    return isInstance;
}

export function InvestmentDetailsAssetAllocationViewModelFromJSON(json: any): InvestmentDetailsAssetAllocationViewModel {
    return InvestmentDetailsAssetAllocationViewModelFromJSONTyped(json, false);
}

export function InvestmentDetailsAssetAllocationViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvestmentDetailsAssetAllocationViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'productSelectedAssetId': !exists(json, 'ProductSelectedAssetId') ? undefined : json['ProductSelectedAssetId'],
        'assetCode': json['AssetCode'],
        'lumpSumPercentage': !exists(json, 'LumpSumPercentage') ? undefined : json['LumpSumPercentage'],
        'transferPercentage': !exists(json, 'TransferPercentage') ? undefined : json['TransferPercentage'],
        'recurringPercentage': !exists(json, 'RecurringPercentage') ? undefined : json['RecurringPercentage'],
        'defaultTransferPercentage': !exists(json, 'DefaultTransferPercentage') ? undefined : json['DefaultTransferPercentage'],
        'unitTransferSourceAmount': !exists(json, 'UnitTransferSourceAmount') ? undefined : json['UnitTransferSourceAmount'],
        'onceOffInvestmentAmount': !exists(json, 'OnceOffInvestmentAmount') ? undefined : json['OnceOffInvestmentAmount'],
        'onceOffInvestmentPercentage': !exists(json, 'OnceOffInvestmentPercentage') ? undefined : json['OnceOffInvestmentPercentage'],
        'isDefaultTransferPercentageMax': !exists(json, 'IsDefaultTransferPercentageMax') ? undefined : json['IsDefaultTransferPercentageMax'],
        'isOwnFundAvailable': !exists(json, 'IsOwnFundAvailable') ? undefined : json['IsOwnFundAvailable'],
        'isUnitTransferAvailable': !exists(json, 'IsUnitTransferAvailable') ? undefined : json['IsUnitTransferAvailable'],
        'jSECode': !exists(json, 'JSECode') ? undefined : json['JSECode'],
    };
}

export function InvestmentDetailsAssetAllocationViewModelToJSON(value?: InvestmentDetailsAssetAllocationViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ProductSelectedAssetId': value.productSelectedAssetId,
        'AssetCode': value.assetCode,
        'LumpSumPercentage': value.lumpSumPercentage,
        'TransferPercentage': value.transferPercentage,
        'RecurringPercentage': value.recurringPercentage,
        'DefaultTransferPercentage': value.defaultTransferPercentage,
        'UnitTransferSourceAmount': value.unitTransferSourceAmount,
        'OnceOffInvestmentAmount': value.onceOffInvestmentAmount,
        'OnceOffInvestmentPercentage': value.onceOffInvestmentPercentage,
        'IsDefaultTransferPercentageMax': value.isDefaultTransferPercentageMax,
        'IsOwnFundAvailable': value.isOwnFundAvailable,
        'IsUnitTransferAvailable': value.isUnitTransferAvailable,
        'JSECode': value.jSECode,
    };
}

